import script from "./indexZentra.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexZentra.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__